<template>
  <div class="notice">
    <Tabs value="name1" :animated="false" v-if="false">
      <TabPane :label="label1" name="name1">
        <div class="notice-content">
          <img src="https://huizhanren.oss-cn-shanghai.aliyuncs.com/cloudExhibition/imgs/201910/c6da5fbaa77a43fbbc4952ccb30aab93.jpg">
          <div class="notice-content-text">
            <p>你收到了14份新周报</p>
            <span>1天前</span>
          </div>
        </div>
        <div class="notice-content">
          <img src="https://huizhanren.oss-cn-shanghai.aliyuncs.com/cloudExhibition/imgs/201910/c6da5fbaa77a43fbbc4952ccb30aab93.jpg">
          <div class="notice-content-text">
            <p>你收到了14份新周报你收到了14份新周报你收到了14份新周报你收到了14份新周报你收到了14份新周报</p>
            <span>1天前</span>
          </div>
        </div>
        <div class="notice-footer">
          <p>清空通知</p>
          <p>查看更多</p>
        </div>
      </TabPane>
      <TabPane :label="label2" name="name2" v-if="false">
        <div class="notice-content">
          <img src="https://huizhanren.oss-cn-shanghai.aliyuncs.com/cloudExhibition/imgs/201910/c6da5fbaa77a43fbbc4952ccb30aab93.jpg">
          <div class="notice-content-text">
            <p>***评论了你</p>
            <p style="color:#888888;">你收到了14份新周报</p>
            <span>1天前</span>
          </div>
        </div>
        <div class="notice-footer">
          <p>清空消息</p>
          <p>查看更多</p>
        </div>
      </TabPane>
      <TabPane :label="label3" name="name3" v-if="false">
        <div class="notice-content">
          <div>
            <div style="width:320px;display:flex;justify-content:space-between">
              <span>任务名称</span>
              <span style="border-radius:5px;padding:0 5px;" class="aftering">马上到期</span>
            </div>
            <p>任务需要在2019-01-12 20：00前启动</p>
          </div>
        </div>
        <div class="notice-footer">
          <p>清空待办</p>
          <p>查看更多</p>
        </div>
      </TabPane>
    </Tabs>
    <div> 
        <div class="notice-content">
          <img src="https://huizhanren.oss-cn-shanghai.aliyuncs.com/cloudExhibition/imgs/201910/c6da5fbaa77a43fbbc4952ccb30aab93.jpg" />
          <div class="notice-content-text">
            <p>你收到了14份新周报</p>
            <span>1天前</span>
          </div>
        </div>
        <div class="notice-content">
          <img src="https://huizhanren.oss-cn-shanghai.aliyuncs.com/cloudExhibition/imgs/201910/c6da5fbaa77a43fbbc4952ccb30aab93.jpg" />
          <div class="notice-content-text">
            <p>你收到了14份新周报你收到了14份新周报你收到了14份新周报你收到了14份新周报你收到了14份新周报</p>
            <span>1天前</span>
          </div>
        </div>
        <div class="notice-footer">
          <p style="color: #888;">清空</p> 
        </div>
    </div> 
  </div>
</template>

<script>
export default {
  data() {
    return {
      num:12
    }
  },
  computed: {
    label1() {
      return `通知(${this.num})`
    },
    label2() {
      return `消息(${this.num})`
    },
    label3() {
      return `待办(${this.num})`
    },
  }
}
</script>

<style lang="scss">
.notice {
  .ivu-tabs-nav {
    width: 100%;
    .ivu-tabs-tab {
      width: 30.5%;
      text-align: center;
    }
  }
}
</style>
<style lang="scss" scoped>
.notice {
  background-color: #fff;
  position: relative;
  &-content {
    width: 100%;
    padding: 10px;
    border-bottom: 1px solid #ddd;
    display: flex;
    &:hover {
      background-color: #f2f2f2;
    }
    img {
      width: 30px;
      height: 30px;
      border-radius: 50%;
    }
    &-text {
      width: 280px;
      margin-left: 20px;
      p {
        width: 100%;
        color: #333;
        white-space:normal;
        word-break: break-all;
      }
      span {
        font-size: 12px;
        color: #888888;
      }
    }
  }
  &-footer {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    p {
      cursor: pointer;
    }
  }
}
.before {
  color: #333;
  background-color: #ddd;
}
.ing {
  color: #1890ff;
  background-color: rgba(24,144,255,0.2);
}
.aftering {
  color: #f5222d;
  background-color: rgba(245,34,45,0.2);
}
.after {
  color: #f37b1d;
  background-color: rgba(243,123,29,0.2);
}
</style>